<script>
    import { onDestroy, createEventDispatcher } from "svelte";

    export let threshold = 0;
    export let horizontal = false;
    export let hasMore = true;

    const dispatch = createEventDispatcher();
    let isLoadMore = false;
    let component;

    $: {
        if (!!component) {
            component.parentNode.addEventListener("scroll", onScroll);
            component.parentNode.addEventListener("resize", onScroll);
        }

    }

    const onScroll = e => {
        const offset = horizontal
            ? e.target.scrollWidth - e.target.clientWidth - e.target.scrollLeft
            : e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;

        if (offset <= threshold) {
            if (!isLoadMore && hasMore) {
                dispatch("loadMore");
            }

            isLoadMore = true;

        } else {
            isLoadMore = false;
        }
    };

    onDestroy(() => {
        if (!component) {
            return;
        }

        component.parentNode.removeEventListener("scroll", null);
        component.parentNode.removeEventListener("resize", null);
    });
</script>

<div bind:this={component} style="width:0px" />